module.exports = __webpack_public_path__ + "img/BfA_min.4117deec.png";